import { useEffect, useState } from "react";
import { UseApi } from "../../../../hooks/use-api";
import { GetAddress } from "../../../../Services/lib/shipping";
import styles from "../RedeemInfo.module.sass";

const UserAddress = ({ item }) => {
	const [address, setAddress] = useState({});

	const [{}, fetchAddress] = UseApi({
		service: GetAddress,
	});

	const fetch = async () => {
		if (item.owner) {
			const res = await fetchAddress(item.owner._id);
			if (res) {
				const tmp = {};
				res.forEach((e) => {
					tmp[e._id] = e;
				});
				setAddress(tmp);
				console.log(tmp);
			}
		}
	};

	useEffect(() => {
		if (item.shipment) fetch();
	}, []);

	return (
		<div className={styles.addresToship}>
			{/* <div className={styles.label}>Address to ship</div> */}
			<div className={styles.flex}>
				<div>
					<div className={styles.flex1}>
						<div className={styles.flex2}>
							<div>Country code:</div>
							<div>{address[item?.shipment?.chosenAddressId]?.CountryCode}</div>
						</div>
						<div className={styles.flex2}>
							<div>State / Province:</div>
							<div>
								{address[item?.shipment?.chosenAddressId]?.PoliticalDivision1}
							</div>
						</div>
					</div>
					<div className={styles.flex1}>
						<div className={styles.flex2}>
							<div>City:</div>
							<div>
								{address[item?.shipment?.chosenAddressId]?.PoliticalDivision2}
							</div>
						</div>
						<div className={styles.flex2}>
							<div>ZIP code:</div>
							<div>
								{address[item?.shipment?.chosenAddressId]?.PostcodePrimaryLow}
							</div>
						</div>
					</div>
					<div className={styles.flex2}>
						<div>Street adddress:</div>
						<div>
							{address[item?.shipment?.chosenAddressId]?.AddressLine.join(" ")}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default UserAddress;
